
const Button = ({ text, onButtonClick, isActive }) => {
	return (
		<a 
			className={isActive ? "bg-primary-50" : ''} 
			onClick={onButtonClick} 
			href="#"
		>
			{text}
		</a>
	);
};

export default Button;